<template>
<div>
<b-tabs pills card>
<b-tab title="Lista Vehiculos">
   <List :mapState="'schoolroutesVehicles'" :showbtn="false" :allDispatch="'schoolRoutesVehiculosAll'"></List>
</b-tab>
<b-tab title="Creacion Vehiculos" active>
  <b-card class="text-center" title="Creacion de vehiculos">
  </b-card>
  <b-card class="text-left">
  <b-row>
    <b-col md="4">
          <label for="Placa">Placa </label>
          <b-form-input v-model="Placa"  type="text"  placeholder="Numero Placa."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Marca">Marca </label>
          <b-form-input v-model="Marca"  type="text"  placeholder="Marca."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Categoria">Categoria </label>
          <b-form-input v-model="Categoria"  type="text"  placeholder="Categoria."></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="NombreRuta">Nombre Vehiculo</label>
          <b-form-input v-model="NombreRuta"  type="text"  placeholder="Nombre Vehiculo"></b-form-input>
    </b-col>
    <b-col md="4">
          <label for="Sillas"># Sillas </label>
          <input v-model="Sillas" type="text" class="form-control" @keypress="onlyNumbers" placeholder="Numero Sillas.">
    </b-col>
    <b-col md="12">
      <br>
        <label for="Observaciones">Observaciones</label>  
        <b-form-textarea id="textarea1" placeholder="" :rows="3" :max-rows="6" v-model="obj">
        </b-form-textarea>
    </b-col>
    <b-col md="3">
        <br>
        <b-button variant="success" @click="enviar" >Crear</b-button>
    </b-col>
  </b-row>
  </b-card>
</b-tab>
</b-tabs>

</div>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
 name: 'vehiculos', 
 data (){
        return{
        Placa:'',
        Marca:'',
        Categoria:'',
        NombreRuta:'',
        Sillas:'',
        obj:'',
        }
 },
  components: {
    List
  },
    methods:{
        onlyNumbers(event) {
            let key = window.event ? event.which : event.keyCode
            if ((key < 48 || key > 57) && key != 8)
                event.preventDefault()
        },
        enviar(){
            if(this.Placa !='' && this.NombreRuta !='' && this.Sillas !='' && this.Marca !='' && this.Categoria !='' && this.obj !=''){
                    let  array={'placa':this.Placa,'nombre_ruta':this.NombreRuta,'sillas':this.Sillas,'marca':this.Marca,'categoria':this.Categoria,'observaciones':this.obj}
                    this.$store.dispatch('schoolroutescrearVehiculos', array).then(Response=>{ 
                    this.varimgtext='<div style="text-align: center;"><h1>Vehiculo Creado</h1></span></div>'  
                    this.$root.showInfoDialog('alerta', this.varimgtext, 'Aceptar')                    
                    this.creardata()                    
                }) 
            }else{
                alert('Tienes Campos Vacios');
            }
             

    },
    creardata(){
      this.Placa='',
      this.NombreRuta='',
      this.Sillas='',
      this.Marca='',
      this.Categoria='',
      this.obj=''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/schoolroutes/vehicles/list.vue